import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useState } from 'react';
import BaseInput from './BaseInput.js';
import Label from './Label.js';
import { ResetIconButton, CheckIcon, VisibilityIconButton } from './Icons.js';
import { StyledIconDiv } from './style.js';

/**
 * type
 */
function Password(_a) {
    var label = _a.label, value = _a.value, validState = _a.validState, readOnly = _a.readOnly, disabled = _a.disabled, inputRef = _a.inputRef, onResetIconClick = _a.onResetIconClick, isFocused = _a.isFocused, props = __rest(_a, ["label", "value", "validState", "readOnly", "disabled", "inputRef", "onResetIconClick", "isFocused"]);
    var _b = useState('password'), type = _b[0], setType = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, __assign({}, props, { label: label, validState: validState, readOnly: readOnly, disabled: disabled, inputValue: value, isFocused: isFocused })),
        React.createElement(BaseInput, __assign({}, props, { inputRef: inputRef, type: type, value: value, labelOfInput: label, validState: validState, readOnly: readOnly, disabled: disabled, isFocused: isFocused })),
        value &&
            !disabled &&
            !readOnly &&
            (isFocused || validState === 'error') && (React.createElement(ResetIconButton, { right: validState === 'success' ? '8' : '4.8', onClick: function () {
                var _a;
                onResetIconClick();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            } })),
        value && validState === 'success' && !readOnly && (React.createElement(StyledIconDiv, { right: "1.6" },
            React.createElement(CheckIcon, null))),
        value && (React.createElement(VisibilityIconButton, { type: type, right: validState !== 'success' || readOnly ? '1.6' : '4.8', onClick: function () {
                if (type === 'password') {
                    setType('text');
                }
                else {
                    setType('password');
                }
            } }))));
}

export { Password as default };
